<template>
  <div>
    <el-card v-if="announcement"  :body-style="{padding: '5px'}">
      <div v-html="announcement"></div>
    </el-card>
  </div>
</template>

<script>
import {request} from '@/network/request'

export default {
  name: 'announcement',
  data () {
    return {
      announcement: ''
    }
  },
  created () {
    this.ad()
  },
  props: {
    data: {
    }
  },
  methods: {
    ad () {
      request({
        url: '/api/Ads',
        method: 'post'
      }).then(res => {
        localStorage.setItem('ad', JSON.stringify(res.data))
        this.announcement = res.data.announcement
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/announcement.vue